<data-table (detail)="onSelect($event)" [columns]="columns" [dataProviderParams]="params" [dataProvider]="pakService"
            [title]="'Packages'" [noCard]="true"></data-table>
